<template>
  <div class="salaire-create page-layout">
    <PageHeader title="Créer un salaire" :has-back="true" @back="goBack" />

    <md-card class="meep-form">
      <md-card-content>
        <div class="meep-input">
          <div class="meep-form-column meep-form-single-column">
            <md-field :class="{ 'md-invalid': errors.has('smic') }">
              <label>SMIC *</label>
              <md-input
                v-model="form.smic"
                v-validate="'required|decimal'"
                name="smic"
                type="smic"
              >
              </md-input>
              <span class="md-error" v-show="errors.has('smic')">
                {{ errors.first("smic") }}
              </span>
            </md-field>
          </div>

          <div class="meep-input">
            <md-field :class="{ 'md-invalid': errors.has('coef1a19') }">
              <label>Coef 1 à 19 *</label>
              <md-input
                v-model="form.coef1a19"
                v-validate="'required|decimal'"
                name="coef1a19"
                type="coef1a19"
              >
              </md-input>
              <span class="md-error" v-show="errors.has('coef1a19')">
                {{ errors.first("coef1a19") }}
              </span>
            </md-field>
          </div>

          <div class="meep-input">
            <md-field :class="{ 'md-invalid': errors.has('coef20plus') }">
              <label>Coef 20 ou plus*</label>
              <md-input
                v-model="form.coef20plus"
                v-validate="'required|decimal'"
                name="coef20Plus"
                type="coef20Plus"
              >
              </md-input>
              <span class="md-error" v-show="errors.has('coef20plus')">
                {{ errors.first("coef20plus") }}
              </span>
            </md-field>
          </div>

          <div class="meep-input">
            <md-field :class="{ 'md-invalid': errors.has('taux_charge') }">
              <label>Taux charge*</label>
              <md-input
                v-model="form.taux_charge"
                v-validate="'decimal'"
                name="taux_charge"
                type="taux_charge"
              >
              </md-input>
              <span class="md-error" v-show="errors.has('taux_charge')">
                {{ errors.first("taux_charge") }}
              </span>
            </md-field>
          </div>

          <div class="md-layout md-alignment-center-right">
            <md-button
              class="md-raised md-primary"
              @click.native="createSalaire"
            >
              Créer un salaire
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import calculatorsModel from "../../../../model/calculators";
import PageHeader from "@/components/PageHeader";

export default {
  components: { PageHeader },
  data() {
    return {
      isDebug: false,
      form: {
        smic: "",
        coef20plus: "",
        coef1a19: "",
        taux_charge: "",
      },
    };
  },
  methods: {
    goBack() {
      window.history.back();
    },
    createSalaire() {
      this.$validator.validateAll().then(result => {
        if (result) {
          calculatorsModel
            .createSalaire(this.form)
            .then(() => {
              this.$toasted.global.AppSucces({
                message: "Le salaire a bien été enregistré",
              });

              this.$router.push("/admin/calculators/salaire/list");
            })
            .catch(err => {
              this.$toasted.global.AppError({
                message: err.msg,
              });
            });
        } else {
          this.$toasted.global.AppInfo({
            message: "Vous devez remplir les champs manquants",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.salaire-create {
  .debug-log {
    max-height: 360px;
    overflow-y: scroll;
  }

  .md-card {
    margin-top: 32px;
    margin-bottom: 32px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
